const licenseRegistrationBarChartData = {
  labels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  datasets: [
    {
      label: "Active",
      data: [120, 190, 130, 170, 160, 150, 180, 170, 160, 190, 200, 210],
      backgroundColor: "rgba(10, 165, 15, 0.5)",
    },
    {
      label: "Inactive",
      data: [90, 120, 100, 140, 130, 110, 150, 140, 130, 160, 170, 180],
      backgroundColor: "rgba(254, 0, 55, 0.5)",
    },
  ],
};

export default licenseRegistrationBarChartData;
